import { Controller } from 'stimulus'
import Deck from '../assets/scripts/deck.js'

const equals = (a, b) =>
  a.length === b.length &&
  a.every((v, i) => v === b[i]);

export default class GameController extends Controller {
  static get targets() {
    return ['question', 'answers'];
  }

  initialize() {
    this.deck = new Deck(this.packSettings);
  }

  connect() {
    this.update();
  }

  get packSettings() {
    return document.getElementById("pack-settings")
                   .getAttribute("data-checkbox-list-included-value")
                   .split(" ");
  }

  reset() {
    this.deck = new Deck(this.packSettings);
  }

  update() {
    if (!equals(this.packSettings, this.deck.packs)) {
      this.reset();
    }

    let nextCard = this.deck.pluck();

    this.questionTarget.innerHTML = nextCard.question;

    this.answersTarget.innerHTML = "";
    nextCard.answers.forEach(answer => {
      let li = document.createElement("li");
      li.innerHTML = answer;
      this.answersTarget.appendChild(li);
    });
  }
}
